var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollContainer",staticClass:"scroll-container"},[_c('div',{ref:"scrollWrapper",staticClass:"scroll-wrapper",style:({ top: _vm.top + 'px' })},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }